import { render, staticRenderFns } from "./SetRecoveryEmail.vue?vue&type=template&id=2eff838a&scoped=true&"
import script from "./SetRecoveryEmail.vue?vue&type=script&lang=ts&"
export * from "./SetRecoveryEmail.vue?vue&type=script&lang=ts&"
import style0 from "./SetRecoveryEmail.vue?vue&type=style&index=0&id=2eff838a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eff838a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardActions,VCardText,VCardTitle,VCol,VForm,VRow,VSpacer})
